import { Component } from '@angular/core';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

@Component({
  host: { 'test-id': 'user-sync-error' },
  selector: 'user-sync-error',
  imports: [FwLayoutContextComponent, FwButtonComponent],
  template: `
    <fw-layout-context
      description="Your user information couldn't sync to the login system. It might take 1-2 minutes for new or updated user data to sync completely. Please wait a moment, then try logging in again. If the issue continues, reach out to support for help."
      icon="rotate-refresh"
      iconColor="secondary"
      title="User Sync Error"
    >
      <fw-button leftIcon="rotate-refresh" size="large" variant="outline" (click)="retry()">Retry</fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100vw;
        height: 100vh;
        background: var(--page-light);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    `,
  ],
})
export class UserSyncErrorComponent {
  retry(): void {
    location.reload();
  }
}
